import request from '@teetsh/app/src/utils/request';
import { saveAs } from 'file-saver';
import { useState } from 'react';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { useTranslation } from 'react-i18next';

interface Props {
  schoolyearId: string;
  schoolId: string;
  livretName: string;
  eleveName: string;
  onStart: () => void;
  onFinished: () => void;
  onError: () => void;
  livretEleveId;
}

export const fetchLivretEleveFromS3 = (s3Url, livretEvalName, eleveName) =>
  fetch(s3Url)
    .then(response => response.blob())
    .then(response => {
      saveAs(
        response,
        eleveName
          ? `${livretEvalName}-${eleveName}.pdf`
          : `${livretEvalName}.pdf`,
      );
    });

export async function downloadLivretEleve(props: Props) {
  const {
    schoolyearId,
    schoolId,
    onStart,
    onFinished,
    onError,
    livretEleveId,
    livretName,
    eleveName,
  } = props;

  onStart();

  const requestURL = `/schoolyears/${schoolyearId}/schools/${schoolId}/livrets-eleves/${livretEleveId}/pdf`;
  try {
    const response = await request(requestURL, {
      method: 'GET',
    });
    const token = response.pdf_token;
    await fetchLivretEleveFromS3(token, livretName, eleveName);
  } catch {
    onError();
  } finally {
    onFinished();
  }
}

export function useDownloadLivretEleve() {
  const { schoolyear, school } = useSchoolSchoolyear();
  const [isDownloading, setIsDownloading] = useState<boolean>(false);
  const { t } = useTranslation(['carnet']);
  const { notifyError } = useNotification();
  const download = ({
    livretEleveId,
    eleveName,
    livretName,
  }: {
    livretEleveId: string;
    eleveName: string;
    livretName: string;
  }) =>
    downloadLivretEleve({
      livretEleveId,
      schoolyearId: schoolyear.id,
      schoolId: school.id,
      eleveName,
      livretName,
      onStart: () => setIsDownloading(true),
      onFinished: () => setIsDownloading(false),
      onError: () =>
        notifyError({
          title: t('carnet:livret.downloadLivretError'),
        }),
    });

  return {
    download,
    isDownloading,
  };
}
